//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      default: '正在加载。。。'
    },
  },
  data() {
    return {}
  },
  components: {},
  created() {
  },
  methods: {

  }
};



// WEBPACK FOOTER //
// ./src/components/cmLoadmore.vue